/**
 * main.js — VoxCar Site entry point
 * Orchestrates all page sections.
 */

import { fetchMarcas }        from './services/marcas.js';
import { fetchTodosVeiculos } from './services/veiculos.js';
import { renderPopulares }    from './components/populares.js';
import { renderEstoque }      from './components/estoque.js';

import { initHeader }         from './components/header.js';
import { initForm }           from './components/form.js';
import { initVender }         from './components/vender.js';
import { initSmoothScroll }   from './components/smooth-scroll.js';
import { applyConfiguracoes } from './components/configuracoes.js';
import { renderFooter }       from './components/footer.js';
import { initComparar, toggleComparar } from './components/comparar.js';

document.addEventListener('DOMContentLoaded', async () => {
  renderFooter();         // ← injeta o footer antes de qualquer config
  initHeader();
  initSmoothScroll();
  applyConfiguracoes();   // ← aplica logo, cor, banners, contato
  initComparar();
  
  renderPopulares();
  renderEstoque(); // Renderiza preview do estoque na home

  // Delegar cliques nos botões "Comparar" (Home)
  document.body.addEventListener('click', e => {
    const btn = e.target.closest('.btn-comparar');
    if (!btn) return;
    
    e.preventDefault();
    e.stopPropagation();
    
    toggleComparar(btn.dataset.carId, {
      slug:  btn.dataset.carSlug,
      img:   btn.dataset.carImg,
      name:  btn.dataset.carName,
      price: btn.dataset.carPrice,
    });
  });


  // Buscador da hero redireciona para a página de estoque
  const searchInput = document.getElementById('search-input');
  const btnBuscar = document.getElementById('btn-buscar');
  const selMarca = document.getElementById('filter-marca');
  const selCambio = document.getElementById('filter-cambio');
  const selCombustivel = document.getElementById('filter-combustivel');
  const selOrdem = document.getElementById('filter-ordem');
  const btnLimpar = document.getElementById('btn-limpar-filtros');
  
  if (selMarca) {
    fetchMarcas().then(({ data: marcas, error }) => {
      if (!error && marcas && marcas.length) {
        marcas.forEach(m => {
          const opt = document.createElement('option');
          opt.value = m.nome.toLowerCase();
          opt.textContent = m.nome;
          selMarca.appendChild(opt);
        });
      }
    });
  }

  if (selCombustivel) {
    fetchTodosVeiculos().then(({ data: veiculos, error }) => {
      if (!error && veiculos && veiculos.length) {
        const combustiveis = [...new Set(veiculos.map(v => v.combustivel).filter(Boolean))];
        combustiveis.sort((a, b) => a.localeCompare(b, 'pt-BR'));
        
        selCombustivel.innerHTML = '<option value="">Todos</option>';
        combustiveis.forEach(c => {
          const opt = document.createElement('option');
          opt.value = c.toLowerCase();
          opt.textContent = c;
          selCombustivel.appendChild(opt);
        });
      }
    });
  }

  if (btnLimpar) {
    btnLimpar.addEventListener('click', () => {
      if (searchInput) searchInput.value = '';
      if (selMarca) selMarca.value = '';
      if (selCambio) selCambio.value = '';
      if (selCombustivel) selCombustivel.value = '';
      if (selOrdem) selOrdem.value = '';
    });
  }
  
  function heroSearch() {
    const params = new URLSearchParams();
    
    if (searchInput && searchInput.value.trim()) {
      params.append('q', searchInput.value.trim());
    }
    if (selMarca && selMarca.value) {
      params.append('marca', selMarca.value);
    }
    if (selCambio && selCambio.value) {
      params.append('cambio', selCambio.value);
    }
    if (selCombustivel && selCombustivel.value) {
      params.append('combustivel', selCombustivel.value);
    }
    if (selOrdem && selOrdem.value) {
      params.append('ordem', selOrdem.value);
    }

    const queryString = params.toString();
    window.location.href = '/estoque' + (queryString ? '?' + queryString : '');
  }

  if (btnBuscar) {
    btnBuscar.addEventListener('click', (e) => {
      e.preventDefault();
      heroSearch();
    });
  }

  if (searchInput) {
    searchInput.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        heroSearch();
      }
    });
  }

  initVender();
  initForm();
});
